import React, { useState } from 'react';
import { Mail, Send } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { toast } from '../hooks/use-toast';
import { submitContact } from '../services/api';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await submitContact(formData);
      toast({
        title: "Message sent!",
        description: "Thank you for reaching out. I'll get back to you soon."
      });
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to send message. Please try again.",
        variant: "destructive"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="py-16 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="mb-16 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Mail size={32} className="text-gray-900" />
            <h1 className="text-4xl md:text-5xl font-serif text-gray-900">Contact</h1>
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            I'd love to hear from you. Whether you have questions about my work,
            want to discuss a project, or just want to say hello.
          </p>
        </div>

        <div className="bg-white border border-gray-200 p-8 md:p-12">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm uppercase tracking-wider text-gray-700 mb-2">
                Name
              </label>
              <Input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full border-gray-300 focus:border-gray-900 focus:ring-gray-900"
                placeholder="Your name"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm uppercase tracking-wider text-gray-700 mb-2">
                Email
              </label>
              <Input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full border-gray-300 focus:border-gray-900 focus:ring-gray-900"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm uppercase tracking-wider text-gray-700 mb-2">
                Message
              </label>
              <Textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={8}
                className="w-full border-gray-300 focus:border-gray-900 focus:ring-gray-900 resize-none"
                placeholder="Your message..."
              />
            </div>

            <Button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-gray-900 text-white hover:bg-gray-800 transition-colors duration-200 py-6 text-sm uppercase tracking-wider"
            >
              {isSubmitting ? (
                'Sending...'
              ) : (
                <span className="flex items-center justify-center gap-2">
                  <Send size={16} />
                  Send Message
                </span>
              )}
            </Button>
          </form>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Or reach me directly at:</p>
          <a
            href="mailto:keith.romero@example.com"
            className="text-lg text-gray-900 hover:text-gray-600 transition-colors duration-200"
          >
            keith.romero@example.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;